/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarNote from 'DesignSystem/Svgs/Tysiav2CalendarNote/index'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/Header/Note"
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarNote
  viewPath={`${viewPath}/Tysiav2CalendarNote`}
 fill2="#8562C7"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="New Calendar Note"
 size="normal"
 weight="semibold"
/>
{children}
</React.Fragment>)
}